import { useState } from 'react';

export default function FooterNewsletter() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    setStatus('loading');
    try {
      const body = new URLSearchParams({ email, name: '' });
      const res = await fetch('https://readdy.ai/api/form/d7fl3295vm7vckkoe6qg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      if (res.ok) {
        setStatus('success');
        setEmail('');
      } else {
        throw new Error();
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <div className="border-b border-white/5" style={{ background: '#0d0d14' }}>
      <div className="max-w-7xl mx-auto px-6 py-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 flex items-center justify-center rounded-lg flex-shrink-0"
              style={{ background: 'rgba(230,57,70,0.12)' }}>
              <i className="ri-mail-send-line text-thl-red text-base" />
            </div>
            <div>
              <p className="text-white font-semibold text-sm">THL Monthly Newsletter</p>
              <p className="text-white/40 text-xs">Logistics insights. No spam. Unsubscribe anytime.</p>
            </div>
          </div>

          {status === 'success' ? (
            <div className="flex items-center gap-2 text-sm text-thl-red font-medium">
              <i className="ri-check-line" /> Subscribed! Check your inbox.
            </div>
          ) : (
            <form
              data-readdy-form
              id="footer-newsletter"
              onSubmit={handleSubmit}
              className="flex gap-2 w-full sm:w-auto"
            >
              <input
                type="email"
                name="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="Your email address"
                required
                className="flex-1 sm:w-60 px-4 py-2.5 rounded-xl text-sm text-white placeholder-white/30 border border-thl-border focus:border-thl-red/40 focus:outline-none transition-colors"
                style={{ background: 'rgba(255,255,255,0.04)' }}
              />
              <button
                type="submit"
                disabled={status === 'loading'}
                className="btn-primary text-sm px-5 py-2.5 disabled:opacity-60 whitespace-nowrap cursor-pointer"
              >
                {status === 'loading' ? <i className="ri-loader-4-line animate-spin" /> : 'Subscribe'}
              </button>
            </form>
          )}
        </div>
        {status === 'error' && (
          <p className="text-thl-red text-xs mt-2 text-right">Something went wrong. Please try again.</p>
        )}
      </div>
    </div>
  );
}
